"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var calculateSystems = function calculateSystems(props, systems) {
  if (props === void 0) {
    props = {};
  }

  return Object.assign.apply(Object, [{}].concat(systems.map(function (system) {
    return system(props);
  })));
}; // TODO: Maybe this can be a tag function?


var extractKeyValuePairs = function extractKeyValuePairs(obj) {
  return Object.keys(obj).map(function (key) {
    return key + ": " + obj[key] + ";";
  }).join('');
}; // TODO: Extract breakpoints


var mediaQuery = function mediaQuery(props, systems) {
  if (props === void 0) {
    props = {};
  }

  var styles = '';
  var mediaQueryMap = [{
    query: 'sm',
    breakpoint: 576
  }, {
    query: 'md',
    breakpoint: 768
  }, {
    query: 'lg',
    breakpoint: 992
  }, {
    query: 'xl',
    breakpoint: 1200
  }];

  if (props.xs) {
    var systemStyles = calculateSystems(props.xs, systems);
    styles += extractKeyValuePairs(systemStyles);
  }

  mediaQueryMap.forEach(function (mediaQuery) {
    if (props[mediaQuery.query]) {
      var systemStyles = calculateSystems(props[mediaQuery.query], systems);
      styles += "@media only screen and (min-width:" + mediaQuery.breakpoint + "px) {\n        " + extractKeyValuePairs(systemStyles) + "\n      }";
    }
  });
  return styles;
};

exports.default = mediaQuery;